import { get, handleError } from '@/lib/http-adapter';
import { AdminUser } from '@/state/admin-users';

export const getAdminUsers = async (queryParams?: {
  role?: AdminUser['role'];
}) => {
  try {
    const url = '/public/admin-users';

    const response = await get<{
      admin_users: AdminUser[];
    }>(url, { params: queryParams });

    return response?.admin_users;
  } catch (error) {
    handleError(error);
  }
};
